import { Form, Input } from "decorator-form";

import { ID } from "common/entities/IEntity";
import { knowledgeBaseIdSelect } from "../util/widget";

@Form({title: "Refine Category Panel Config"})
export default class RefineCategoryPanelConfig {


	// TODO switch this to GUID
	@Input({type: knowledgeBaseIdSelect, title: "Knowledge Base"})
	public knowledgeBaseId: ID;

}



// WEBPACK FOOTER //
// ./src/panels/kb/config/RefineCategoryPanelConfig.ts